module.exports = __webpack_public_path__ + "media/configurations/SX-X-O-009fb51b.png";